import { useState } from "react";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import { customToast } from "../../../../../../../components/toast/custom-react-toastify/v1";
import { useProductOptionsValueContextHook } from "../../../../contexts/ProductOptionsContext";
import { DoorayMessageApi } from "../../../../../../../apis/DoorayMessageApi";

export function TdDooray({ returnExchange }) {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <td className="p-8 border-b-[1px] border-[#dee2e6] text-[#495057]">
                <button
                    type="button"
                    className="bg-[var(--blueColor1)] text-white rounded-[3px] h-[30px] px-[10px] font-semibold cursor-pointer"
                    onClick={(e) => {
                        e.stopPropagation();
                        setModalOpen(true);
                    }}
                >
                    발송
                </button>
            </td>
            {modalOpen && (
                <DooraySenderModal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    returnExchange={returnExchange}
                />
            )}
        </>
    );
}

function DooraySenderModal({ open, onClose, returnExchange }) {
    const productOptionsValueContextHook = useProductOptionsValueContextHook();
    const productOptions = productOptionsValueContextHook?.productOptions;
    const productOption = productOptions?.find(
        (option) => option.code === returnExchange?.releaseOptionCode,
    );
    const [claimReason, setClaimReason] = useState("");
    const [inspectionResult, setInspectionResult] = useState(
        returnExchange.inspectionResultMemo || "",
    );

    // 발송될 메시지 생성
    const getMessageFirstLine = () => {
        if (productOption && productOption?.product) {
            return `${returnExchange.receiver} / ${returnExchange.receiverContact1} / ${returnExchange.waybillNumber} / ${returnExchange.salesChannel} / ${productOption?.product?.name} ${productOption.name}`;
        }
        return `${returnExchange.receiver} / ${returnExchange.receiverContact1} / ${returnExchange.waybillNumber} / ${returnExchange.salesChannel} / ${returnExchange.prodName} ${returnExchange.optionName}`;
    };

    const getClaimTypeLabel = () => {
        return returnExchange.returnExchangeType === "RETURN"
            ? "반품사유"
            : "교환사유";
    };

    const handleCopyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };

    const handleSendMessage = async () => {
        const message = `${getMessageFirstLine()}\n\n${getClaimTypeLabel()} : ${claimReason}\n\n검수결과 : ${inspectionResult}`;
        await DoorayMessageApi.sendMessage({
            botType: "RETURN_EXCHANGE",
            message,
        });
        customToast.success("메시지가 발송되었습니다.");
        onClose();
    };

    return (
        <>
            <CustomDialog open={open} onClose={onClose} maxWidth="xl">
                <CustomDialog.Header className="p-2">
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>
                        두레이 발송
                    </CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>

                <div className="p-4">
                    <div className="flex gap-4">
                        {/* 왼쪽: 발송될 메시지 */}
                        <div className="flex-1 border border-gray-300 rounded p-4">
                            <h3 className="font-semibold mb-4 text-lg">
                                발송될 메시지
                            </h3>
                            <div className="space-y-4">
                                {/* 기본 정보 (읽기 전용) */}
                                <div className="bg-gray-50 p-3 rounded">
                                    <p className="text-sm whitespace-pre-wrap">
                                        {getMessageFirstLine()}
                                    </p>
                                </div>

                                {/* 반품/교환 사유 (입력 가능) */}
                                <div>
                                    <label className="block mb-2 font-medium text-sm">
                                        {getClaimTypeLabel()} :
                                    </label>
                                    <textarea
                                        className="w-full border border-gray-300 rounded p-2 min-h-[60px] text-sm"
                                        value={claimReason}
                                        onChange={(e) =>
                                            setClaimReason(e.target.value)
                                        }
                                        placeholder="사유를 입력해주세요"
                                    />
                                </div>

                                {/* 검수결과 (입력 가능) */}
                                <div>
                                    <label className="block mb-2 font-medium text-sm">
                                        검수결과 :
                                    </label>
                                    <textarea
                                        className="w-full border border-gray-300 rounded p-2 min-h-[80px] text-sm"
                                        value={inspectionResult}
                                        onChange={(e) =>
                                            setInspectionResult(e.target.value)
                                        }
                                        placeholder="검수결과를 입력해주세요"
                                    />
                                </div>

                                {/* 미리보기 */}
                                <div className="bg-blue-50 p-3 rounded">
                                    <h4 className="font-medium text-sm mb-2 text-blue-800">
                                        미리보기
                                    </h4>
                                    <div className="text-sm whitespace-pre-wrap text-gray-700">
                                        {getMessageFirstLine()}
                                        {"\n\n"}
                                        {getClaimTypeLabel()} :{" "}
                                        {claimReason || "?"}
                                        {"\n\n"}
                                        검수결과 : {inspectionResult || "?"}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 오른쪽: 클레임 및 메모 정보 */}
                        <div className="flex-1 border border-gray-300 rounded p-4">
                            <h3 className="font-semibold mb-4 text-lg">
                                참고 정보
                            </h3>
                            <div className="space-y-3">
                                {/* 클레임 시스템 */}
                                <div>
                                    <div className="flex justify-between items-center mb-1">
                                        <label className="font-medium text-sm text-gray-700">
                                            클레임 (시스템)
                                        </label>
                                        <button
                                            type="button"
                                            className="text-xs bg-gray-200 hover:bg-gray-300 px-2 py-1 rounded"
                                            onClick={() =>
                                                handleCopyToClipboard(
                                                    returnExchange.claimSystem ||
                                                        "",
                                                )
                                            }
                                        >
                                            복사
                                        </button>
                                    </div>
                                    <div className="bg-gray-50 p-2 rounded text-sm min-h-[40px]">
                                        {returnExchange.claimSystem || "N/A"}
                                    </div>
                                </div>

                                {/* 클레임 고객 */}
                                <div>
                                    <div className="flex justify-between items-center mb-1">
                                        <label className="font-medium text-sm text-gray-700">
                                            클레임 (고객)
                                        </label>
                                        <button
                                            type="button"
                                            className="text-xs bg-gray-200 hover:bg-gray-300 px-2 py-1 rounded"
                                            onClick={() =>
                                                handleCopyToClipboard(
                                                    returnExchange.claimCustomer ||
                                                        "",
                                                )
                                            }
                                        >
                                            복사
                                        </button>
                                    </div>
                                    <div className="bg-gray-50 p-2 rounded text-sm min-h-[40px]">
                                        {returnExchange.claimCustomer || "N/A"}
                                    </div>
                                </div>

                                {/* 메모1 */}
                                <div>
                                    <div className="flex justify-between items-center mb-1">
                                        <label className="font-medium text-sm text-gray-700">
                                            메모 1
                                        </label>
                                        <button
                                            type="button"
                                            className="text-xs bg-gray-200 hover:bg-gray-300 px-2 py-1 rounded"
                                            onClick={() =>
                                                handleCopyToClipboard(
                                                    returnExchange.returnExchangeMemo1 ||
                                                        "",
                                                )
                                            }
                                        >
                                            복사
                                        </button>
                                    </div>
                                    <div className="bg-gray-50 p-2 rounded text-sm min-h-[40px]">
                                        {returnExchange.returnExchangeMemo1 ||
                                            "N/A"}
                                    </div>
                                </div>

                                {/* 메모2 */}
                                <div>
                                    <div className="flex justify-between items-center mb-1">
                                        <label className="font-medium text-sm text-gray-700">
                                            메모 2
                                        </label>
                                        <button
                                            type="button"
                                            className="text-xs bg-gray-200 hover:bg-gray-300 px-2 py-1 rounded"
                                            onClick={() =>
                                                handleCopyToClipboard(
                                                    returnExchange.returnExchangeMemo2 ||
                                                        "",
                                                )
                                            }
                                        >
                                            복사
                                        </button>
                                    </div>
                                    <div className="bg-gray-50 p-2 rounded text-sm min-h-[40px]">
                                        {returnExchange.returnExchangeMemo2 ||
                                            "N/A"}
                                    </div>
                                </div>

                                {/* 검수결과 메모 */}
                                <div>
                                    <div className="flex justify-between items-center mb-1">
                                        <label className="font-medium text-sm text-gray-700">
                                            검수결과 (기존)
                                        </label>
                                        <button
                                            type="button"
                                            className="text-xs bg-gray-200 hover:bg-gray-300 px-2 py-1 rounded"
                                            onClick={() =>
                                                handleCopyToClipboard(
                                                    returnExchange.inspectionResultMemo ||
                                                        "",
                                                )
                                            }
                                        >
                                            복사
                                        </button>
                                    </div>
                                    <div className="bg-gray-50 p-2 rounded text-sm min-h-[40px]">
                                        {returnExchange.inspectionResultMemo ||
                                            "N/A"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end p-4">
                    <button
                        type="button"
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 rounded px-4 py-2 mr-2"
                        onClick={onClose}
                    >
                        닫기
                    </button>
                    <button
                        type="button"
                        className="bg-[var(--blueColor1)] hover:bg-blue-600 text-white rounded px-4 py-2 font-semibold"
                        onClick={() => handleSendMessage()}
                    >
                        발송
                    </button>
                </div>
            </CustomDialog>
        </>
    );
}
